/**
 * Constantes des réglages « Suivi » d'un site client : formats et bornes des ID (réexportés par
 * `WebsiteTypes.ts`), page de doc destinée aux agences (réexportée par `site-tracking-config.ts`).
 *
 * ⚠️ Module SANS dépendance npm : le générateur de la doc (`docs-site/scripts/generate-user-docs.ts`)
 * l'importe en chemin relatif et tourne sans les `node_modules` de la racine (docs-site s'installe
 * en standalone : job CI `build-docs` et image docs-site). Le générateur ne doit atteindre, même
 * par un `import type`, aucun module qui importe TypeBox (`WebsiteTypes.ts`, `site-tracking-config.ts`) :
 * `tsx` échoue à l'exécution sur un import de valeur, `next build` au contrôle de types sur les deux.
 */

/** Chemin, dans la doc, de la page de référence « Événements de suivi » destinée aux agences. */
export const SITE_TRACKING_EVENTS_DOC_SLUG = 'tracking-events';
export const SITE_TRACKING_EVENTS_DOC_PATH = `/website/${SITE_TRACKING_EVENTS_DOC_SLUG}`;

// Nombre maximum d'ID Google par site (conteneurs GTM, GA4, Google Ads confondus).
export const GOOGLE_TRACKING_IDS_MAX = 5;

// Formats d'ID de tracking acceptés. Fix du trou d'injection : ces valeurs sont
// interpolées dans des inline scripts côté custom-websites (ConditionalTracking) —
// validation serveur (saveTracking), miroir client (TrackingSettingsModal) et garde
// au rendu (valeurs stockées avant le fix). PAS de `pattern` TypeBox sur les champs
// optionnels de TrackingConfigSchema : un `''` envoyé pour effacer ferait 400 via AJV.
export const GOOGLE_TRACKING_ID_REGEX = /^(GTM-[A-Z0-9]+|G-[A-Z0-9]+|AW-[A-Z0-9]+|UA-[A-Z0-9-]+)$/;
export const META_PIXEL_ID_REGEX = /^\d+$/;
// Pixel TikTok : identifiant alphanumérique MAJUSCULE (ex. D158OVBC77UCOE1UEPC0).
// Même rôle anti-injection que les deux regex ci-dessus — la valeur est interpolée
// dans un inline script côté custom-websites.
// ⚠️ Casse-SENSIBLE, comme GOOGLE_TRACKING_ID_REGEX : l'appelant (saveTracking et son
// miroir TrackingSettingsModal) normalise en `toUpperCase()` AVANT de tester. Un `/i`
// ici ferait diverger validation et valeur stockée — un id saisi en minuscules
// passerait le test puis serait silencieusement muté.
export const TIKTOK_PIXEL_ID_REGEX = /^[A-Z0-9]{8,32}$/;
// Libellé de conversion Google Ads (la partie après le `/` de `send_to`), interpolé côté
// navigateur dans `send_to` : même rôle anti-injection. Casse significative, pas de normalisation.
export const GOOGLE_ADS_CONVERSION_LABEL_REGEX = /^[A-Za-z0-9_-]{1,64}$/;
